exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select-asset-dialog[data-v-c7089d0c]{\n  height:515px;\n  overflow:hidden\n}\n[data-v-c7089d0c] .el-dialog__header{\n  border-bottom:1px solid rgba(236,236,236,.89)\n}\n[data-v-c7089d0c] .el-dialog__footer{\n  border-top:1px solid rgba(236,236,236,.89)\n}\n[data-v-c7089d0c] .el-dialog__body{\n  padding:0 20px\n}", ""]);

// exports
